import React from 'react';
import './UploadTile.css';
import { AiOutlineClose } from 'react-icons/ai';
import Button from 'react-bootstrap/Button';
import {Link} from 'react-router-dom';


const stickTile = (props) => {


    return (
        <div className="UploadTile" >
            <h2>Submit figures </h2> 
            <Link to="../">
                <Button  variant="outline-secondary" size="sm" className="CloseButton">
                    <AiOutlineClose />
                </Button>
            </Link>
            <br />
            <p>You can submit your own figures by sending your .stk files to <a href="mailto:support@pivotanimator.net">support@pivotanimator.net</a>.<br/>
            You can also submit packs of figures by sending a piv file, but please don't include background images.
                The figure name will be set from the file name.<br/>
                Submitted files will be reviewed and considered for inclusion in the next update.<br/>
                Please include your creator name and optionally a link to your YouTube channel so that we can credit you on the website.<br/>
                <b>Please only submit your own work.</b><br/>
                There's no need to send images as these will be generated from the file.
            </p>
            

        </div>
    )
};

export default stickTile;